import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_atomic_crm_dark.svg";
import lightModeLogo from "./logos/logo_atomic_crm_light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "EUR";

export const defaultTitle = "Avante";

export const defaultCompanySectors = [
  { value: "health-clinic", label: "Clínica / salud" },
  { value: "speech-therapy", label: "Logopedia" },
  { value: "physiotherapy", label: "Fisioterapia" },
  { value: "dental", label: "Clínica dental" },
  { value: "psychology", label: "Psicología" },
  { value: "veterinary", label: "Veterinaria" },
  { value: "public-sector", label: "Administración pública" },
  { value: "construction-engineering", label: "Construcción e ingeniería" },
  { value: "energy", label: "Energía" },
  { value: "retail", label: "Comercio" },
  { value: "hospitality", label: "Hostelería" },
  { value: "education", label: "Educación" },
  { value: "professional-services", label: "Servicios profesionales" },
  { value: "technology", label: "Tecnología" },
  { value: "other", label: "Otros" },
];

// in-development, delivered and maintenance follow a won deal while it is being built.
export const defaultDealStages = [
  { value: "opportunity", label: "Oportunidad" },
  { value: "proposal-sent", label: "Propuesta enviada" },
  { value: "in-negociation", label: "En negociación" },
  { value: "won", label: "Ganada" },
  { value: "in-development", label: "En desarrollo" },
  { value: "delivered", label: "Entregada" },
  { value: "maintenance", label: "En mantenimiento" },
  { value: "lost", label: "Perdida" },
  { value: "delayed", label: "Aplazada" },
];

export const defaultDealPipelineStatuses = [
  "won",
  "in-development",
  "delivered",
  "maintenance",
];

export const defaultDealCategories = [
  { value: "crm", label: "CRM" },
  { value: "app", label: "App" },
  { value: "web", label: "Web" },
  { value: "landing", label: "Landing page" },
  { value: "ai-automation", label: "Automatización / IA" },
  { value: "ui-design", label: "Diseño UI" },
  { value: "maintenance", label: "Mantenimiento" },
  { value: "consulting", label: "Consultoría" },
  { value: "other", label: "Otro" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frío", color: "#7dbde8" },
  { value: "warm", label: "Templado", color: "#e8cb7d" },
  { value: "hot", label: "Caliente", color: "#e88b7d" },
  { value: "in-contract", label: "Con contrato", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Ninguno" },
  { value: "call", label: "Llamada" },
  { value: "email", label: "Email" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "meeting", label: "Reunión" },
  { value: "demo", label: "Demo" },
  { value: "follow-up", label: "Seguimiento" },
  { value: "proposal", label: "Propuesta" },
  { value: "ship", label: "Entrega" },
  { value: "lunch", label: "Comida" },
  { value: "thank-you", label: "Agradecimiento" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
